module.exports = __webpack_public_path__ + "img/3_22.7a942490.png";